import { ApiQueryParams } from '../types/ApiQueryParams';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import { transformDateIntoLocalString } from '@/utils/date';
import { ApiRespAssignmentMetricsByWorkload } from '../types/AssignmentMetricsResponse';

export const fetchAssignmentsByWorkloads = async (
    queryParams: ApiQueryParams
): Promise<ApiRespAssignmentMetricsByWorkload> => {
    const params = new URLSearchParams({
        fromDate: transformDateIntoLocalString(queryParams.fromDate),
        toDate: transformDateIntoLocalString(queryParams.toDate),
        workstreamDefinitionIds: queryParams.workstreamDefinitionIds.join(',')
    });

    return await fetchFromLambda(`/workactivity/back-office/assignment/snapshot/workloads?${params}`);
};